/* eslint-disable react/display-name */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, Modal, Table } from 'antd'
const onCell = _ => ({ style: { paddingTop: '10px', paddingBottom: '10px' } })
const onHeaderCell = _ => ({ style: { backgroundColor: '#eee' } })

export const columns = [
  {
    title: 'Type',
    dataIndex: 'severity',
    key: 'severity',
    render: text =>
      isNaN(text) ? 'Warning' : parseInt(text) === 0 ? 'Warning' : 'Error',
    onCell,
    onHeaderCell,
    width: 100,
  },
  {
    title: 'Code',
    dataIndex: 'errorCode',
    key: 'errorCode',
    onCell,
    onHeaderCell,
    width: 100,
  },
  {
    title: 'Message',
    dataIndex: 'errorMessage',
    key: 'errorMessage',
    render: (text, record) => text || record.error || '',
    onCell,
    onHeaderCell,
  },
]

export const JcTmpErrorTable = ({
  errors,
  pagination = false,
  style,
  scroll,
}) => (
  <Table
    rowKey={d => d.errorCode + d.severity + d.errorMessage}
    columns={columns}
    dataSource={errors}
    onRow={record => {
      if (record.severity === 1 || record.severity === '1') {
        return { style: { backgroundColor: 'lightpink' } }
      } else return { style: { backgroundColor: 'lightyellow' } }
    }}
    pagination={pagination}
    size="small"
    // style={{ maxHeight: '400px', overflowY: 'auto' }}
    style={style}
    scroll={scroll || { y: 400 }}
  />
)

export default ({
  title = 'Error/Warning',
  visible,
  errors,
  closeErrorPrompt = _ => _,
}) => {
  return (
    <Modal
      visible={visible}
      onOk={_ => closeErrorPrompt()}
      onCancel={_ => closeErrorPrompt()}
      title={title}
      width={800}
      style={{ zIndex: 10000 }}
      footer={
        <Button type="primary" onClick={_ => closeErrorPrompt()}>
          Close
        </Button>
      }
      zIndex={10000}
    >
      <JcTmpErrorTable errors={errors} />
    </Modal>
  )
}

export const isErrorContains = (jcTmpErrorList = []) => {
  if (Array.isArray(jcTmpErrorList)) {
    const isError = (jcTmpErrorList || []).map(f => f.severity).filter(f => !!f)

    return isError.find(f => f === '1' || f === 1)
  }
  return false
}

export const isErrorContainsTmpError = (jcTmpErrorList = []) => {
  if (Array.isArray(jcTmpErrorList)) {
    const isError = (jcTmpErrorList || []).map(f => f.severity).filter(f => !!f)

    return isError.find(f => f === '1' || f === 1)
  }
  return false
}
